export default
{
	availableUnits: 10,
	score: {
		min: 4,
		max: 8,
        displayMax: 11
	},
	name: "delier3",
	day: 2,
	date: {
		time: "09:33",
		day: "scene.date.text" 
	},
	patientState: 0,
	delirium: {
		initialState: "oranje",
		clockPosition: {
			x: 774,
			y: 180
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier3/${locale}/delier_3_nacht_ochtend_blinds-dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier3/${locale}/delier_3_nacht_ochtend_blinds-dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier3/${locale}/delier_3_nacht_ochtend_blinds-dicht_di.flv"
			}
		],
		roomViewToggleButtonPosition: {
			x: 1378,
			y: 335
		}
	},
	room: {
		backgroundImage: {
			blindsOpenUrl: "delier3/delier3_nurseview_room_blinds_open.jpg",
			blindsClosedUrl: "delier3/delier3_nurseview_room_blinds_closed.jpg"
		},
		clock: {
			blindsOpenUrl: "delier3/delier3_nurseview_room_blinds_open_klok.png",
			blindsClosedUrl: "delier3/delier3_nurseview_room_blinds_closed_klok.png"
		}
	},
	end: {
		clockPosition: {
			x: 781,
			y: 188
		},
		videoUrls: [
			{
				whiteboardState: 0,
				blindsState: 0,
				url: "delier3/${locale}/delier_3_slot_blinds_dicht.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 0,
				url: "delier3/${locale}/delier_3_slot_blinds_dicht_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 0,
				url: "delier3/${locale}/delier_3_slot_blinds_dicht_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 0,
				url: "delier3/${locale}/delier_3_slot_blinds_dicht_wo.flv"
			},
			{
				whiteboardState: 0,
				blindsState: 1,
				url: "delier3/${locale}/delier_3_slot_blinds_open.flv"
			},
			{
				whiteboardState: 1,
				blindsState: 1,
				url: "delier3/${locale}/delier_3_slot_blinds_open_ma.flv"
			},
			{
				whiteboardState: 2,
				blindsState: 1,
				url: "delier3/${locale}/delier_3_slot_blinds_open_di.flv"
			},
			{
				whiteboardState: 3,
				blindsState: 1,
				url: "delier3/${locale}/delier_3_slot_blinds_open_wo.flv"
			}
		]
	},
	transitions: [
		{
			deliriumState: "groen",
			target: "delier5"
		},
		{
			deliriumState: "oranje",
			target: "delier6"
		},
		{
			deliriumState: "rood",
			target: "delier7"
		}
	],
	mediaUrls: [
		{
			categoryName: "communiceren",
			value: "delier3/${locale}/delier_3_dialoog_startloop.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientlatenslapen",
			value: "delier3/${locale}/delier_3_dialoog_latenslapen.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "patientvoorstellenchirurg",
			value: "delier3/${locale}/delier_3_dialoog_doorvrorientatie.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "roomingin",
			value: "delier3/${locale}/delier_3_dialoog_partner.flv"
		},
		{
			categoryName: "communiceren",
			actionName: "afrondenenkamerverlaten",
			value: "delier3/${locale}/delier_3_dialoog_dag.flv"
		}
	]
}